import script from "./hsyqScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./hsyqScreen.vue?vue&type=script&setup=true&lang=js"

import "./hsyqScreen.vue?vue&type=style&index=0&id=7f6afbe7&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f6afbe7"]])

export default __exports__